import Identity from './identity';
import { logPrefix } from './constants';

import { isLegacyGoogleSetting, LegacyGoogleSettings } from './socialSignOnTypes';

export interface Options {
  apiOrigin?: string;
  baseDomain?: string;
  google?: LegacyGoogleSettings | typeof google;
  profileStorageOpt?: {
    storageExp?: Date;
    ignoreProfile?: boolean;
  };
  ampReaderId?: string;
}
/**
 * Sets options for the SDK.
 *
 * @param {Options} options
 *
 * Set your cdn API origin as `apiOrigin`.
 *
 * Specify a `baseDomain` if you wish to use the same session across subdomains.
 * When you set a `baseDomain`, the Identity SDK will use Cookie storage to store your user's Identity & Profile.
 *
 * Specify `google.auth2` if you have already loaded the Google SDK
 * (https://apis.google.com/js/platform.js) on the page (recommended). If not
 * provided, the Identity SDK will attempt to inject the Google SDK into the
 * page when calling `initGoogleLogin` or `initGoogleSDK`.
 * Provide `google.clientId` to set a default Google API client ID that the SDK
 * will use when calling any Google related Identity SDK methods.
 *
 * Specify `profileStorageOpt.storageExp` to manually set expiration date for `userProfile` stored as a cookie.
 *
 * Set `profileStorageOpt.ignoreProfile` to `true` to prevent user's profile from being stored in user's browser.
 * `Identity.userProfile` would need to be used to access `userProfile`.
 */

export default function options(options: Options) {
  if (options) {
    Identity.apiOrigin =
      (options.apiOrigin && options.apiOrigin.replace(/\/$/, '')) || Identity.apiOrigin;

    Identity.baseDomain = options.baseDomain || Identity._baseDomain;
    if (options.google) {
      if (isLegacyGoogleSetting(options.google)) {
        Identity._google = {
          ...Identity._google,
          ...options.google
        };
      } else {
        Identity._google = options.google ?? Identity._google;
      }
    }

    Identity.profileStorageOpt = {
      storageExp: options.profileStorageOpt?.storageExp || Identity._profileStorageOpt?.storageExp,
      ignoreProfile:
        options.profileStorageOpt?.ignoreProfile !== undefined
          ? options.profileStorageOpt?.ignoreProfile
          : Identity._profileStorageOpt?.ignoreProfile
    };

    Identity.ampReaderId = options.ampReaderId || Identity.ampReaderId;
  } else {
    console.warn(`${logPrefix} No options specified when calling Identity.options`);
  }
}
